import {
  CLIENT_ACTION,
  INVOICE_ACTION,
  CONTRACT_ACTION,
  TIMESHEET_ACTION,
} from "../../redux/action";


const currentDate = new Date();
const formattedDate = currentDate.toLocaleDateString("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric"
});

const ReportStructure = {
  "Sign Up & Registration": [
    {
      label: "Registration reports",
      API: CLIENT_ACTION.getOverAllClients,
      headers: [
        { id: "1", label: "Date" },
        { id: "2", label: "Client Name" },
        { id: "3", label: "Email" },
        { id: "4", label: "Phone" },
        { id: "5", label: "Handled By" },
        { id: "6", label: "Location" },
        { id: "7", label: "Type" },
        { id: "8", label: "Status" },
        { id: "9", label: "Source" },
      ],
      filters: [
        {
          type: "datepicker",
          labelname: "Start Date",
          value: formattedDate,
          key: "start_date",
        },
        {
          type: "datepicker",
          labelname: "End Date",
          value: formattedDate,
          key: "end_date",
        },
      ],
    },
  ],
  Invoice: [
    {
      label: "Collection/invoice report",
      API: INVOICE_ACTION.getAllInvoices,
      headers: [
        { id: "1", label: "Date" },
        { id: "3", label: "Client Name" },
        { id: "3", label: "Invoice No." },
        { id: "4", label: "Email" },
        // { id: "5", label: "Phone" },
        { id: "6", label: "Handled By" },
        { id: "7", label: "Location" },
        { id: "8", label: "Type" },
        { id: "9", label: "Invoice Amount" },
        { id: "13", label: "Paid Amount" },
        { id: "14", label: "Pending Amount" },
        { id: "10", label: "Invoice Status" },
        { id: "11", label: "Paid Date" },
        { id: "12", label: "Payment Method" },
      ],
      filters: [
        {
          type: "datepicker",
          labelname: "Start Date",
          value: null,
          key: "start_date",
        },
        {
          type: "datepicker",
          labelname: "End Date",
          value: null,
          key: "end_date",
        },
      ],
    },
    // {
    //   label: "Revenue by Associate (Employee)",
    //   API: () => INVOICE_ACTION.getAllInvoices({ revenue_by_employee: true }),
    //   headers: [
    //     { id: "1", label: "Employee Name" },
    //     { id: "2", label: "No. of Customers" },
    //     { id: "3", label: "No. of Payments Done" },
    //     { id: "4", label: "No. of Pending Invoices" },
    //     { id: "5", label: "Amount Collected" },
    //     { id: "6", label: "Amount Pending" },
    //   ],
    //   filters: [
    //     {
    //       type: "datepicker",
    //       labelname: "Start Date",
    //       value: null,
    //       key: "start_date",
    //     },
    //     {
    //       type: "datepicker",
    //       labelname: "End Date",
    //       value: null,
    //       key: "end_date",
    //     },
    //     {
    //       type: "select",
    //       labelname: "Manager",
    //       value: 1,
    //       dropdown: [],
    //       key: "employee_id",
    //     },
    //     {
    //       type: "select",
    //       labelname: "Employee",
    //       value: 1,
    //       dropdown: [],
    //       key: "employee_id",
    //     },
    //   ],
    // }
    // {
    //   label: "Contract report",
    //   API: CONTRACT_ACTION.getAllContracts,
    //   headers: [
    //     { id: "1", label: "Date" },
    //     { id: "2", label: "Customer ID" },
    //     { id: "3", label: "Client Name" },
    //     { id: "3", label: "Contract No./Invoice No." },
    //     { id: "4", label: "Email" },
    //     { id: "5", label: "Phone" },
    //     { id: "6", label: "Handled By" },
    //     { id: "7", label: "Location" },
    //     { id: "8", label: "Type" },
    //     { id: "3", label: "Contract Amount" },
    //     { id: "3", label: "Contract Status" },
    //     { id: "8", label: "Approval Date" },
    //   ],
    //   filters: [
    //     {
    //       type: "datepicker",
    //       labelname: "Start Date",
    //       value: null,
    //       key: "start_date",
    //     },
    //     {
    //       type: "datepicker",
    //       labelname: "End Date",
    //       value: null,
    //       key: "end_date",
    //     },
    //   ],
    // },
  ],
  "Payments & Revenue": [
    {
      label: "Revenue comparison report- Monthly/Quarterly/yearly",
      API: INVOICE_ACTION.getAllInvoices,
      headers: [
        { id: "1", label: "Date" },
        { id: "3", label: "Client Name" },
        { id: "3", label: "Invoice No." },
        { id: "4", label: "Email" },
        // { id: "5", label: "Phone" },
        { id: "6", label: "Handled By" },
        { id: "7", label: "Location" },
        { id: "8", label: "Type" },
        { id: "9", label: "Invoice Amount" },
        { id: "10", label: "Invoice Status" },
        // { id: "11", label: "Payment Date" },
        // { id: "12", label: "Mode of Payment" },
      ],
      filters: [
        {
          type: "datepicker",
          labelname: "Start Date",
          value: null,
          key: "start_date",
        },
        {
          type: "datepicker",
          labelname: "End Date",
          value: null,
          key: "end_date",
        },
      ],
    },
    // {
    //   label: "Revenue report- Location and employee/Associate wise",
    //   API: INVOICE_ACTION.getAllInvoices,
    //   headers: [
    //     { id: "1", label: "Date" },
    //     { id: "2", label: "Customer ID" },
    //     { id: "3", label: "Client Name" },
    //     { id: "3", label: "Invoice No." },
    //     { id: "4", label: "Email" },
    //     { id: "5", label: "Phone" },
    //     { id: "6", label: "Handled By" },
    //     { id: "7", label: "Location" },
    //     { id: "8", label: "Type" },
    //     { id: "11", label: "Payment Date" },
    //     { id: "12", label: "Mode of Payment" },
    //   ],
    //   filters: [
    //     {
    //       type: "datepicker",
    //       labelname: "Start Date",
    //       value: null,
    //       key: "start_date",
    //     },
    //     {
    //       type: "datepicker",
    //       labelname: "End Date",
    //       value: null,
    //       key: "end_date",
    //     },
    //     {
    //       type: "select",
    //       labelname: "Location",
    //       value: 1,
    //       dropdown: [],
    //       key: "location_id",
    //     },
    //     {
    //       type: "select",
    //       labelname: "Employee",
    //       value: 1,
    //       dropdown: [],
    //       key: "employee_id",
    //     },
    //   ],
    // },
  ],
  Clients: [
    {
      label: "Client list- All clients",
      API: CLIENT_ACTION.getOverAllClients,
      headers: [
        { id: "1", label: "Date" },
        { id: "3", label: "Client Name" },
        { id: "4", label: "Email" },
        { id: "5", label: "Phone" },
        { id: "63", label: "Handled By" },
        { id: "77", label: "Location" },
        { id: "88", label: "Type" },
        { id: "89", label: "Status" },
        { id: "83", label: "Source" },
      ],
      filters: [
        {
          type: "datepicker",
          labelname: "Start Date",
          value: null,
          key: "start_date",
        },
        {
          type: "datepicker",
          labelname: "End Date",
          value: null,
          key: "end_date",
        },
      ],
    },
    {
      label: "Client list- Individual",
      API: CLIENT_ACTION.getIndividualClients,
      headers: [
        { id: "1", label: "Date" },
        { id: "3", label: "Client Name" },
        { id: "4", label: "Email" },
        { id: "5", label: "Phone" },
        { id: "63", label: "Handled By" },
        { id: "77", label: "Location" },
        { id: "88", label: "Type" },
        { id: "89", label: "Status" },
        { id: "83", label: "Source" },
      ],
      filters: [
        {
          type: "datepicker",
          labelname: "Start Date",
          value: null,
          key: "start_date",
        },
        {
          type: "datepicker",
          labelname: "End Date",
          value: null,
          key: "end_date",
        },
      ],
    },
    {
      label: "Client list- Business",
      API: CLIENT_ACTION.getBusinessClients,
      headers: [
        { id: "1", label: "Date" },
        { id: "3", label: "Client Name" },
        { id: "4", label: "Email" },
        { id: "5", label: "Phone" },
        { id: "63", label: "Handled By" },
        { id: "77", label: "Location" },
        { id: "88", label: "Type" },
        { id: "89", label: "Status" },
        { id: "83", label: "Source" },
      ],
      filters: [
        {
          type: "datepicker",
          labelname: "Start Date",
          value: null,
          key: "start_date",
        },
        {
          type: "datepicker",
          labelname: "End Date",
          value: null,
          key: "end_date",
        },
      ],
    },
  ],
  Timesheet: [
    {
      label: "Timesheet summary report",
      API: TIMESHEET_ACTION.getTimesheetReport,
      headers: [
        { id: "employee_name", label: "Employee Name" },
        { id: "billable_hours", label: "Billable Hours" },
        { id: "non_billable_hours", label: "Non-Billable Hours" },
        { id: "idle_hours", label: "Idle Time" },
        { id: "total_hours", label: "Total Hours" },
      ],
      filters: [
        {
          type: "datepicker",
          labelname: "Start Date",
          value: null,
          key: "start_date",
        },
        {
          type: "datepicker",
          labelname: "End Date",
          value: null,
          key: "end_date",
        },
      ],
    },
  ],
};
export default ReportStructure;
